<template>
  <h1>Contact Us</h1>
  <div class="responsive">
    <h3>
      Kerry Gilberti, Director
      <a class="email" href="mailto:kerrygilberti10@gmail.com"
        >kerrygilberti10@gmail.com</a
      >
    </h3>
    <h3>
      Renee Frontale, Producer
      <a class="email" href="mailto:ssfrontale@twcny.rr.com"
        >ssfrontale@twcny.rr.com</a
      >
    </h3>
  </div>
</template>

<script>
export default {};
</script>

<style>
.email {
  color: white;
}
</style>
